




















































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import DataPanel from '@/components/DataPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import { DepartmentApi } from '@/http';
@Component({
    components: { BaseContainer, DataPanel, PageDescribe },
})
export default class DepartManagement extends Vue {
    public $refs: {
        vtree: HTMLFormElement;
        departForm: HTMLFormElement;
    };
    public treeData = [];
    public defaultExpandIds = []; // 存放要默认展开的节点id
    public loading: boolean = false;
    //父级部门显隐
    public topLevel: boolean = false;
    // 验证规则
    public formRules = formRules;
    public detailTitle: string = '';
    public title: string = '';
    public dialogFormAdd: boolean = false;
    public searchValue: any = {
        name: '',
    };
    public departForm: any = {
        name: '',
        parentId: '',
        fullName: '',
        level: '',
        remark: '',
    };
    public labelPosition: string = 'left';
    public defaultProp = {
        label: (data, node) => {
            return data.name ? data.name : data.userName;
        },
        children: 'childrenList',
    };
    public bm: boolean = false;
    mounted() {
        this.loadDepartList();
    }
    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }

    //获取部门信息
    public async loadDepartList() {
        await DepartmentApi.GetDepartmentList({ isNeedUser: true }).then((res) => {
            this.treeData = res;
        });
    }

    //新增一级部门
    public addDepartment() {
        this.reset();
        this.title = '新增部门';
        this.departForm.level = '1';
        this.departForm.parentId = '';
        this.departForm.fullName = '';
        this.dialogFormAdd = true;
    }
    // 新增部门
    public NodeAdd(node, data) {
        this.title = '新增部门';
        this.reset();
        this.breadList.length = 0;
        this.dialogFormAdd = true;
        this.departForm.level = node.level + 1;
        this.departForm.parentId = node.data.id;
        let selectNode = this.$refs.vtree.getNode(node); //  获取点击当节点的dom的信息
        this.getparentsNode(selectNode); //调用递归函数
        this.departForm.fullName = this.breadList.join('-');
    }

    // 编辑部门
    //编辑时的节点id
    public editNodeId: string = '';
    //编辑时的node和data
    public editNode: any;
    public editData: any;
    public NodeEdit(node, data) {
        this.editNodeId = data.id;
        this.editNode = node;
        this.editData = data;
        this.title = '编辑部门';
        if (node.level > 1) {
            let selectNode = this.$refs.vtree.getNode(node); //  获取点击当节点的dom的信息
            this.getparentsNode(selectNode); //调用递归函数
            let i = this.breadList.indexOf(data.name);
            i != -1 ? this.breadList.splice(i, 1) : this.breadList;
            this.departForm.fullName = this.breadList.join('-');
        } else {
            this.departForm.fullName = '';
        }
        DepartmentApi.GetDepartmentDetail(node.data.id).then((res) => {
            this.departForm.id = res.id;
            this.departForm.remark = res.remark ? res.remark : '';
            this.departForm.name = res.name;
            this.departForm.level = res.level;
            this.departForm.parentId = res.parentId ? res.parentId : '';
            this.dialogFormAdd = true;
        });
    }

    // 删除部门
    // public NodeDel(node, data) {
    //     this.$confirm('是否删除该部门？')
    //         .then((e) => {
    //             DepartmentApi.DelDepartment(data.id)
    //                 .then(() => {
    //                     this.$message({
    //                         type: 'success',
    //                         message: '删除成功！',
    //                     });
    //                     this.loadDepartList();
    //                 })
    //                 .catch((error) => {});
    //         })
    //         .catch((err) => {});
    // }
    public dataRow: any;
    public NodeDel(node, data) {
        this.dataRow = data;
        this.dialogConfig = {
            title: '删除该部门',
            show: true,
        };
    }
    async confirmOk() {
        DepartmentApi.DelDepartment(this.dataRow.id)
            .then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功！',
                });
                this.loadDepartList();
            })
            .catch((error) => {});
        this.dialogConfig = {
            show: false,
        };
    }
    public reset() {
        this.departForm = {
            name: '',
            parentId: '',
            fullName: '',
            level: '',
            remark: '',
        };
    }
    //保存部门
    public submitAdd() {
        this.loading = true;
        let patrn = /[`-]/im;
        if (this.title == '新增部门') {
            this.$refs.departForm.validate((valid) => {
                if (valid) {
                    // 如果包含特殊字符"-"给出提示
                    if (patrn.test(this.departForm.name)) {
                        this.$message.warning("部门名称存在特殊字符'-',请重新输入！");
                        this.loading = false;
                    } else {
                        DepartmentApi.AddDepartment({
                            name: this.departForm.name,
                            parentId: this.departForm.parentId,
                            fullName: !this.departForm.fullName ? this.departForm.name : this.departForm.fullName + '-' + this.departForm.name,
                            level: this.departForm.level,
                            remark: this.departForm.remark,
                        })
                            .then((res) => {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功！',
                                });
                                this.loading = false;
                                this.dialogFormAdd = false;
                                this.loadDepartList();
                            })
                            .catch((error) => {
                                this.loading = false;
                                this.dialogFormAdd = false;
                            });
                    }
                } else {
                    this.loading = false;
                }
            });
        } else {
            this.$refs.departForm.validate((valid) => {
                if (valid) {
                    if (patrn.test(this.departForm.name)) {
                        this.$message.warning("部门名称存在特殊字符'-',请重新输入！");
                        this.loading = false;
                    } else {
                        DepartmentApi.EditDepartment(this.departForm.id, {
                            name: this.departForm.name,
                            parentId: this.departForm.parentId,
                            fullName: !this.departForm.fullName ? this.departForm.name : this.departForm.fullName + '-' + this.departForm.name,
                            level: this.departForm.level,
                            remark: this.departForm.remark,
                        })
                            .then((response) => {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功',
                                });
                                this.loading = false;
                                this.dialogFormAdd = false;
                                this.loadDepartList();
                                if (this.clickNodeId == this.editNodeId) {
                                    this.deptNodeClick(this.editData, this.editNode);
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                this.dialogFormAdd = false;
                            });
                    }
                } else {
                    this.loading = false;
                }
            });
        }
    }
    public handleClose() {
        this.$refs.departForm.resetFields();
        this.reset();
        this.dialogFormAdd = false;
    }

    public parentDepartment: string = ''; //上级部门及员工所属部门
    public currentDepartment: string = ''; //当前部门名称
    public userName: string = '';
    public phoneNumber: string = '';
    public remark: string = '';
    //员工OR部门
    public isuser: boolean = true;
    //点击时节点id
    public clickNodeId: string = '';
    //部门节点被点击时获取父级信息
    deptNodeClick(item, e) {
        this.clickNodeId = item.id;
        this.loading = true;
        this.breadList.length = 0;
        this.parentDepartment = '';
        this.remark = '';
        this.phoneNumber = '';
        this.userName = '';
        this.currentDepartment = '';
        if (item.isUser) {
            this.isuser = true;
            DepartmentApi.GetUserDetail(e.data.id)
                .then((res) => {
                    this.userName = res.realName;
                    this.phoneNumber = res.phoneNumber;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                });
        } else {
            this.isuser = false;
            DepartmentApi.GetDepartmentDetail(e.data.id)
                .then((res) => {
                    this.remark = res.remark;
                    this.currentDepartment = res.name;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                });
        }
        if (!item.isUser) {
            this.detailTitle = '部门详情';
        } else {
            this.detailTitle = '员工详情';
        }
        if (e.level > 1) {
            this.topLevel = false;
            let selectNode = this.$refs.vtree.getNode(e); //  获取点击当节点的dom的信息
            this.getparentsNode(selectNode); //调用递归函数
            let i = this.breadList.indexOf(item.name ? item.name : item.userName);
            i != -1 ? this.breadList.splice(i, 1) : this.breadList;
            this.parentDepartment = this.breadList.join('-');
        } else {
            this.topLevel = true;
        }
    }
    // 递归
    public breadList = [];
    getparentsNode(node) {
        if (!node.parent) {
            return;
        }
        this.breadList.unshift(node.label);
        this.getparentsNode(node.parent); //调用递归
    }

    //过滤节点-->查询
    filterChange() {
        // console.log(this.$refs.vtree)
        this.$refs.vtree.filter(this.searchValue.name);
    }
    filterNode(value, data) {
        if (!value) return true;
        return data.name ? data.name.indexOf(value) !== -1 : data.userName.indexOf(value) !== -1;
    }

    /**保留已展开节点--------------start-------------------------------- */
    // 树节点展开
    handleNodeExpand(data) {
        // 保存当前展开的节点
        let flag = false;
        this.defaultExpandIds.some((item) => {
            if (item === data.id) {
                // 判断当前节点是否存在， 存在不做处理
                flag = true;
                return true;
            }
        });
        if (!flag) {
            // 不存在则存到数组里
            this.defaultExpandIds.push(data.id);
        }
    }
    // 树节点关闭
    handleNodeCollapse(data) {
        // 删除当前关闭的节点
        this.defaultExpandIds.some((item, i) => {
            if (item === data.id) {
                this.defaultExpandIds.splice(i, 1);
            }
        });
        this.removeChildrenIds(data); // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
    }
    // 删除树子节点
    removeChildrenIds(data) {
        const ts = this;
        if (data.children) {
            data.children.forEach(function (item) {
                const index = ts.defaultExpandIds.indexOf(item.id);
                if (index > 0) {
                    ts.defaultExpandIds.splice(index, 1);
                }
                ts.removeChildrenIds(item);
            });
        }
    }
    /**--------------保留已展开节点end-------------------------------- */
}
